// W3C Draft: https://wicg.github.io/netinfo/#networkinformation-interface
export interface NetworkInformation extends Record<string, string | number | boolean> {
  readonly downlink: number;
  readonly downlinkMax: number;
  readonly effectiveType: string;
  readonly rtt: number;
  readonly saveData: boolean;
  readonly type: string;
}

interface YammerNavigator extends Navigator {
  readonly connection: NetworkInformation;
}

declare const navigator: YammerNavigator;

type GetNetworkInformation = () => Partial<NetworkInformation>;

export const getNetworkInformation: GetNetworkInformation = () => {
  const connection = navigator.connection;

  if (!connection) {
    return {};
  }

  const { downlink, downlinkMax, effectiveType, rtt, saveData, type } = connection;

  return { downlink, downlinkMax, effectiveType, rtt, saveData, type };
};
